<div class="h-full bg-grey-white_smoke dark:bg-contrast-black">
    <div class="mb-4 flex justify-between bg-white px-3 pb-3 pt-3 shadow">
        <button
            class="var-app-light:text-primary w-8 pt-1 text-secondary md:hidden"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="back()"
            type="button">
            <ion-icon
                class="mr-1 text-xl dark:filter-yellow"
                [attr.aria-hidden]="true"
                focusable="false"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
            </ion-icon>
        </button>

        <div class="flex-align-center mr-6 flex grow justify-center">
            <h1 class="var-app-light-dark:font-bold text-base font-semibold">{{ 'ABOUT_TITLE' | translate }}</h1>
        </div>
    </div>

    <div class="mb-2 bg-white px-4 py-4 shadow-md">
        <h2
            class="mb-4 text-xs font-semibold text-grey-dark dark:text-contrast-yellow"
            [class.uppercase]="!env.REMOVE_UPPERCASE">
            {{ 'APP_VERSION' | translate }}
        </h2>
        <p class="text-base">{{ appVersion }}</p>
        <p class="text-base">{{ 'COPYRIGHT' | translate }} {{ currentYear + ',' }} {{ 'RIDANGO' | translate }}</p>
    </div>

    <div class="mb-2 bg-white px-4 py-4 shadow-md" *ngIf="isLoggedIn ? customerId : anonymousId">
        <h2
            class="mb-4 text-xs font-semibold text-grey-dark dark:text-contrast-yellow"
            [class.uppercase]="!env.REMOVE_UPPERCASE">
            {{ (isLoggedIn ? 'CUSTOMER_ID' : 'DEVICE_ID') | translate }}
        </h2>
        <p class="text-base">{{ isLoggedIn ? customerId : anonymousId }}</p>
    </div>
</div>
